"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

var _colors = _interopRequireDefault(require("../../../constants/colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var FileSpreadsheetIcon = function FileSpreadsheetIcon(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 256 256",
    role: "img",
    "aria-label": "Spreadsheet file icon"
  }, props), _react.default.createElement("path", {
    d: "M178.67 24H220c6.62 0 12 5.38 12 12v41.33h-53.33V24zm0 77.33H232v53.33h-53.33v-53.33zm-24 77.34V232h-53.33v-53.33h53.33zM24 220v-41.33h53.33V232H36c-6.62 0-12-5.38-12-12zm196 12h-41.33v-53.33H232V220c0 6.62-5.38 12-12 12zm0-232h-90c-6.63 0-12 5.37-12 12s5.37 12 12 12h24.67v130.67H24V132c0-6.63-5.37-12-12-12s-12 5.37-12 12v88c0 19.85 16.15 36 36 36h184c19.85 0 36-16.15 36-36V36c0-19.85-16.15-36-36-36z"
  }), _react.default.createElement("path", {
    d: "M118 132H74c-4.89 0-9.29-2.97-11.13-7.5-1.83-4.54-.73-9.73 2.79-13.13l33.05-31.91c2.12-2.15 3.29-5 3.29-8.02C102 65.13 96.87 60 90.57 60c-3.05 0-5.92 1.19-8.08 3.35-4.69 4.69-12.28 4.69-16.97 0-4.69-4.69-4.69-12.28 0-16.97C72.21 39.69 81.1 36 90.57 36 110.11 36 126 51.89 126 71.43c0 9.46-3.69 18.36-10.38 25.05l-.15.15L103.7 108H118c6.63 0 12 5.37 12 12s-5.37 12-12 12zM32 96c-6.63 0-12-5.37-12-12V40.95c-4.71 4.22-11.96 4.07-16.49-.46-4.69-4.69-4.69-12.28 0-16.97l20-20A12 12 0 0 1 36.59.92 11.98 11.98 0 0 1 44 12v72c0 6.63-5.37 12-12 12z"
  }));
};

FileSpreadsheetIcon.displayName = 'FileSpreadsheetIcon';
FileSpreadsheetIcon.propTypes = {
  color: _propTypes.string,
  size: _propTypes.number
};
FileSpreadsheetIcon.defaultProps = {
  color: _colors.default.iconColor,
  size: 40
};
var _default = FileSpreadsheetIcon;
exports.default = _default;